import { settings } from '../store/settings.store';


let accountEl: HTMLTambrAccountElement;

export function openAccountFlow() {
  if ( document.getElementsByTagName('tambr-account').length ) return;
  accountEl = document.createElement('tambr-account');
  document.body.appendChild( accountEl );
  document.body.style.overflow = 'hidden';  
}

export function closeAccountFlow() {
  if ( document.getElementsByTagName('tambr-account').length ) {
    accountEl.remove();
    document.body.style.overflow = settings.pageBodyOverflow;
  }
}
